import React from 'react';
import './PayMeMoney.css';

export class PayMeMoney extends React.Component {

  onClicked = ($event) => {
    const { onClick } = this.props;
    if (!!onClick) {
      onClick($event);
    }
  };

  render () {
    const { upgrade, normal } = this.props;
    // If we don't need to upgrade don't render
    if (!upgrade) {
      return null;
    }

    return (
      <div
        className={ `${normal ? 'pay-upgrade' : 'pill-upgrade'} clickable`}
        onClick={ this.onClicked }>
        <i className="material-icons">lock_outline</i>
      </div>
    );
  }

}
